module.exports = __webpack_public_path__ + "static/media/person_yiling.ae4be1d5.png";